var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"clas":"back-link"}},[_c('div',{staticClass:"grid-x grid-margin-x back-link__subline"},[_c('router-link',{staticClass:"back-link__link",attrs:{"to":{ name: _vm.path }}},[_vm._v(" Back to "+_vm._s(_vm.label)+" ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7eb26b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/back-link/back-link.vue
// module id = null
// module chunks = 